import React from 'react';

const TimeslotPicker = (props) => {
    let {date, disabled, availableSessions, compact} = props;

    let displayDay = displayDay || date.format("dddd");
    let displayDate = date.format("DD/MM");

    return (
        <div className="row">
            <div className="col-md-12">
                <div className={"text-center" + (compact ? "" : " card-slim")}>
                    {!compact ? (
                        <p><i className="fa fa-clock-o" /> {displayDay} ({displayDate})</p>
                    ) : null}

                    <div className="row timeslots">
                        {availableSessions.map(function (session) {
                            return (
                                <div key={session.sessionId} className="col-xs-4 col-md-12 slot">
                                    <button className="btn btn-block btn-sm btn-default" disabled={disabled} onClick={() => props.onQuickSelect(props.date, session.sessionId, false, this)}>
                                        {session.sessionDescription}<br />{session.displayText}
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimeslotPicker;


// WEBPACK FOOTER //
// ./app/booking/components/timeslotPicker.js